export const getAgentsUrl = (locationId: string) => `/business/locations/${locationId}/agents`;

/** All agents for the current business (every location). Used by telephony assignment dropdowns. */
export const getBusinessAgentsUrl = () => '/business/agents';

export const getAgentUrl = (locationId: string, id: string | number) =>
  `/business/locations/${locationId}/agents/${id}`;

export const getAgentStatusUrl = (locationId: string, id: string | number) =>
  `/business/locations/${locationId}/agents/${id}/is_ready`;

export const getAgentTemplatesUrl = (locationId: string) => `/business/locations/${locationId}/agent_templates`;

export const getAgentDataSetsUrls = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/datasets`;

export const getAgentDataSetUrls = (locationId: string, agentId: string, id: string) =>
  `/business/locations/${locationId}/agents/${agentId}/datasets/${id}`;

export const getAmbientSoundsUrl = () => '/business/ambient_sounds';

export const getThinkingSoundsUrl = () => '/business/thinking_sounds';

export const getLiveKitTokenUrl = (agentToken: string) => `/public/agents/${agentToken}/access_token`;

export const getPublicAgentWidgetConfigUrl = (agentToken: string) => `/public/agents/${agentToken}/widget_config`;

export const getAgentPronunciationRulesUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/pronunciation_rules`;

export const getAgentPronunciationRuleUrl = (locationId: string, agentId: string, id: number) =>
  `/business/locations/${locationId}/agents/${agentId}/pronunciation_rules/${id}`;
